/**
 * Firebase Configuration
 */
import { initializeApp } from 'firebase/app';
import { enableIndexedDbPersistence, initializeFirestore } from 'firebase/firestore';
let firebaseApp = null;
let firestoreDb = null;
/**
 * Initialize Firebase with configuration
 */
export function initializeFirebase(config) {
    if (firebaseApp) {
        return firebaseApp;
    }
    console.log('Initializing Firebase with config:', {
        projectId: config.projectId,
        authDomain: config.authDomain
    });
    firebaseApp = initializeApp(config);
    console.log('Firebase app initialized successfully');
    return firebaseApp;
}
/**
 * Get Firestore instance
 */
export function getDb() {
    if (!firestoreDb) {
        if (!firebaseApp) {
            throw new Error('Firebase not initialized. Call initializeFirebase() first.');
        }
        console.log('Initializing Firestore with experimentalForceLongPolling...');
        // Initialize Firestore with settings that help with connectivity
        firestoreDb = initializeFirestore(firebaseApp, {
            experimentalForceLongPolling: true, // Helps with connectivity issues
            experimentalAutoDetectLongPolling: false,
        });
        console.log('Firestore initialized successfully');
        // Try to enable offline persistence (optional, will fail silently if not supported)
        enableIndexedDbPersistence(firestoreDb).catch((err) => {
            console.warn('IndexedDB persistence not enabled:', err.code);
        });
    }
    return firestoreDb;
}
/**
 * Get Firebase app instance
 */
export function getApp() {
    if (!firebaseApp) {
        throw new Error('Firebase not initialized. Call initializeFirebase() first.');
    }
    return firebaseApp;
}
